import axios from 'axios'
import abLS from '@/business/abLocalStorage'
import Vue from 'vue'
const $vm = new Vue()

axios.interceptors.request.use(config => {
  if (!config.customHeaders) {
    config.headers = {
      accessToken: abLS.getAccessToken() || ''
    }
  }
  if (!config.noLoading || config.name) {
    $vm.$loading.show()
  }
  return config
})

axios.interceptors.response.use(
  ({ config, data: res }) => {
    $vm.$loading.hide()
    // 下载，直接是流文件
    if (config && config.responseType === 'blob') {
      return Promise.resolve(res)
    }
    if (res.ret) {
      return Promise.resolve(res.data)
    } else {
      // -99 为需要重新登录
      if (res.errcode === -99) {
        abLS.clearLocalStorage()
        window.location.href = '/login'
      }
      $vm.$Message.error({
        content: res.errmsg || '请求错误'
      })
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        errorNo: res.errcode,
        errorMsg: res.errmsg || '请求错误'
      })
    }
  },
  error => {
    const { response = {} } = error
    const res = response.data || {}
    $vm.$loading.hide()
    $vm.$Message.error({
      content: res.errmsg || '请求错误'
    })
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      errorNo: res.errcode,
      errorMsg: res.errmsg || '请求错误'
    })
  }
)

export default axios
